<script>
    import Slideshow from '../componants/Slideshow.svelte';
 

    let images1 = [
      '/images/YWarws/bedroom.jpg',
      '/images/YWarws/bathroom.jpg',
      '/images/YWarws/bedroom3.jpg',
      '/images/YWarws/living-room.jpg',
      '/images/YWarws/living-room2.jpg',
      '/images/YWarws/bedroom2.jpg' ,
      '/images/YWarws/bedroom3.jpg' ,
      '/images/YWarws/downstairs.jpg',
      '/images/YWarws/outside.jpg',
      '/images/YWarws/outside-table.jpg',
     
  ];

  let images2 = [
    '/images/warwsbach/bedroom3.jpg',
    '/images/warwsbach/bedroom2.jpg',
      '/images/warwsbach/patio.jpg',
      '/images/warwsbach/livingroom.jpg',
      '/images/warwsbach/bathroom.jpg',
      '/images/warwsbach/kitchen.jpg',
      '/images/warwsbach/outside.jpg',
  ];
</script>

<main>

  
  
<h1>YWarws</h1>
<ul class='rooms'>
    <li>Sleeps 4</li>
    <li>Bedrooms 2</li>
    <li>Bathrooms 2</li>
</ul>
<p>
    Y Warws is a recently converted "Welsh Tourist Board" 4 Star rated holiday accommodation suitable for up to four people. The ground floor has a living/dining area and fitted kitchen (which includes electric cooker, microwave, dishwasher, washing machine). TV/DVD and Radio/CD player. There are two en-suite bedrooms upstairs (one double and one twin). The french windows in the living area and double bedroom have small balconies with outstanding views of Cader Idris Mountain range and surrounding countryside.
</p>
<div class='slidecontainer'><Slideshow images={images1} /></div>

<ul>
    <li>Underfloor heating of Y Warws ensures a comfortable stay at any time of the year. There is also a private garden area with spectacular views across to Cader Idris and down the Mawddach Estuary.</li>
    <li>All bed linen and towels are provided.</li>
    <li>Garden furniture and barbecue is provided.</li>
    <li>Enclosed private parking adjacent to accommodation.</li>
    <li>Pets welcome.</li>
    <li>Free Wi Fi.</li>
</ul>

<h1>Warws Bach</h1>
<ul class='rooms'>
    <li>Sleeps 2</li>
    <li>Bedrooms 1</li>
    <li>Bathrooms 1</li>
</ul>
<p>
    Warws Bach is a recently converted "Welsh Tourist Board" 4 Star rated holiday accommodation suitable for two persons with living/dining area and fitted kitchen on the ground floor and en-suite bedroom upstairs with double bed. There are outstanding views down the Mawddach Estuary from the living area and the bedroom. The porch/conservatory area has magnificent views across to the Cader Idris Mountain range and down the Mawddach Estuary. Underfloor heating of Warws Bach ensures a comfortable stay all year round. Garden furniture and barbecue is provided.

</p>

<div class='slidecontainer'><Slideshow images={images2} /></div>
<ul>
    <li>All bed linen and towels are provided.</li>
<li>Enclosed private parking adjacent to accommodation.</li>
<li>TV/DVD </li>
<li>Pets welcome.</li>
<li>Free Wi Fi.</li>
</ul>
</main>


<style>

main{
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
}
.rooms{
    display: flex;
    flex-direction: row;
    color: rgb(27, 45, 19);
    margin: auto;
    width: 100%;
}
li{
    
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    margin-left:-20px;
    color: beige;
    text-align: justify;
}
.rooms li{
    padding: 0px 20px 0px 20px;
    list-style-type: none;
    font-style: italic;
    list-style-type: none;
}
p{
    text-align: justify;
    padding-bottom:10px;
    padding-top: 10px;
    margin: auto;
    width: 100%;
}
h1{
  color: #7A7361;
}

.slidecontainer{
margin-left:0px;
    width: 100%;
    
}
@media screen and (max-width: 800px) {
    main {
      width: 100%;
      text-align: center;
      margin: auto;
    }
    
    
  }
</style>